module.exports = __webpack_public_path__ + "static/media/pins.4259b29f.svg";